import isBot from 'isbot';
import { setIsBot } from 'store/userEnvironment/userEnvironmentActions';

const loadBotDetection = ({ req, store }) => {
  store.dispatch(setIsBot(isBot(req?.headers['user-agent'])));
};

export default loadBotDetection;
